const INSI_CONSULT_APP_URL = new URL(process.env.REACT_APP_INSI_CONSULT_APP_URL || '')

export { INSI_CONSULT_APP_URL }
